import getStore from '../store/store';

export const CATEGORY_ID_FOR_SPELLING = '19a112ec-21fd-432a-9d1f-195e5e94a00b';
export const CATEGORY_ID_FOR_GRAMMAR = '04aeb01b-175a-4385-9257-bfc5f7e4b650';

export default function isCategoryEnabled(categoryId: string): boolean {
    const store = getStore();
    const {
        overriddenCategories,
        spellCheckEnabled,
        grammarEnabled,
    } = store.settingsDialogViewState;

    if (categoryId === CATEGORY_ID_FOR_SPELLING) {
        return spellCheckEnabled === true;
    } else if (categoryId === CATEGORY_ID_FOR_GRAMMAR) {
        return grammarEnabled === true;
    } else if (overriddenCategories?.has(categoryId)) {
        return overriddenCategories?.get(categoryId) === true;
    }

    return true;
}
